var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVerify = function SvgVerify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-29a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h29Zm-1.291 3.042h-8.032v1.39h3.777v7.358H25.09V6.623h-1.952v5.167h-.66v1.39h8.032v-1.39h-2.317V8.013h2.317v-1.39h-2.317v-2.19h2.317v-1.39Zm-16.568 0h-2.05L8.016 13.138h2.05l1.994-5.21 2.274 5.21H16.3L13.52 6.79h-1.025l1.446-3.749ZM6.752 6.103H4V7.48h.828v4.128c0 .216.04.415.12.597.08.183.187.344.323.485a1.493 1.493 0 0 0 .93.442l.158.007h1.123l.534-1.208h-.829a.42.42 0 0 1-.309-.126.415.415 0 0 1-.118-.221l-.008-.088V6.103Zm14.195-.168h-2.78v1.39h.828v4.254a1.527 1.527 0 0 0 .45 1.096 1.539 1.539 0 0 0 .936.441l.158.008h1.138l.533-1.208h-.828a.42.42 0 0 1-.309-.126.415.415 0 0 1-.118-.221l-.008-.088V5.935ZM6.289 3.042H4.014l1.011 2.26h2.289l-1.025-2.26ZM20.483 3h-2.302l1.025 2.12h2.302L20.483 3Z",
    fill: "var(--primaryColor)",
    fillRule: "evenodd"
  })));
};

export default SvgVerify;